// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__4Mze1","window":"styles_window__Hq4bU"};